<div
  class="operation-inner"
  *ngFor="let operationFormGroup of operationsFormArray.controls; let index = index; trackBy: trackByIndex"
>
  <y42-operation-input-number-form-group
    class="contents"
    [form]="operationFormGroup"
    [columnType]="columnType"
    [index]="index"
    [enableMoreConditions]="enableMoreConditions"
    [operatorOptions]="operatorOptions"
  ></y42-operation-input-number-form-group>
</div>
